import { render, staticRenderFns } from "./add-technician-to-order-modal.vue?vue&type=template&id=2e28973a&lang=pug"
import script from "./add-technician-to-order-modal.vue?vue&type=script&lang=js"
export * from "./add-technician-to-order-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports